import Model from '../utils/Model'

export default class VirtualBillType {
  constructor(code, englishName, chineseName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'VirtualBillType'
export const NORMAL_VIRTUAL_BILL_TYPE = new VirtualBillType(0, 'Normal', '普通')
export const MERGE_VIRTUAL_BILL_TYPE = new VirtualBillType(1, 'Merge', '并单')

export const VIRTUAL_BILL_TYPES = new Set([NORMAL_VIRTUAL_BILL_TYPE, MERGE_VIRTUAL_BILL_TYPE])
export const BILL_TYPE_VALUES = [
  { serialNumber: 0, code: 'Normal', name: 'Normal', localName: '普通' },
  { serialNumber: 1, code: 'Merge', name: 'Merge', localName: '并单' }
]
/**
 *  return null:没找到.
 */
export function getVirtualBillTypeByCode(code) {
  return Model.getObjByCode(code, VirtualBillType)
}
